import { render } from "./Menu.vue?vue&type=template&id=bc9a508a&scoped=true&ts=true"
import script from "./Menu.vue?vue&type=script&lang=ts"
export * from "./Menu.vue?vue&type=script&lang=ts"

import "./Menu.vue?vue&type=style&index=0&id=bc9a508a&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_mmx/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc9a508a"]])

export default __exports__